// extracted by mini-css-extract-plugin
module.exports = {"toggle":"_c36ac2d","toggleSlider":"_45fdf19","toggleOptionLabel":"_611773e","toggleOptionLabelSelected":"_db86647","toggleOptionInput":"_1b8e330","toggleOf2":"_ca9d0e7"};